import React from 'react';

export const Fragment = React.Fragment;

function createElementWithKey(type, props, key) {
  if (key === undefined) {
    return React.createElement(type, props);
  }

  return React.createElement(type, { ...props, key });
}

export function jsx(type, props, key) {
  return createElementWithKey(type, props, key);
}

export const jsxs = jsx;
export const jsxDEV = jsx;
